import { Navigate, useLocation, useParams } from "react-router-dom";
import { Loading } from "@/components/atoms";
import { useOperator } from "@/hooks";
import { usePermissions } from "@/permissions";
import { EPermission } from "@/permissions/types";
import { useAppSelector } from "@/redux/hooks";
import { selectIsOnboardingComplete } from "@/redux/slices/quickSetup";

export const Home = () => {
  const operator = useOperator();
  const { operatorId } = useParams();
  const { hasPermission } = usePermissions();
  const location = useLocation();
  const isOnboardingComplete = useAppSelector(selectIsOnboardingComplete);
  const isAdmin = operator.roles.includes("Fa_Access") || operator.roles.includes("Owner") || operator.roles.includes("Admin");

  const currentOperatorId = operatorId || operator.id;
  const isAlreadyInOperatorPath = location.pathname.includes(`/operator/${currentOperatorId}`);

  if (!isAdmin) {
    const path = isAlreadyInOperatorPath ? "bookings" : `operator/${currentOperatorId}/bookings`;
    return <Navigate to={path} />;
  }

  if (isOnboardingComplete === null) {
    return <Loading />;
  }

  let destination: string;
  if (isOnboardingComplete) {
    destination = "bookings";
  } else {
    const canViewGetStarted = hasPermission(EPermission.ProviderGetStartedManage);
    destination = canViewGetStarted ? "get-started" : "quick-setup";
  }
  const path = isAlreadyInOperatorPath ? destination : `operator/${currentOperatorId}/${destination}`;

  return <Navigate to={path} />;
};
